module.exports = "<nv-react-component component=\"OrgLevelProfile\"></nv-react-component>";